import {
    LoginTypes,
    RegisterTypes,
    InstitutionRegister,
    InstitutionLogin,
    ResponseLoginSuccess,
    UserCerqTypes,
    RefreshTokenTypes,
    RefreshTokenInterface,
    AgendaTypes,
    AgendaInterface,
} from './types'

export function loginRequest(payload: InstitutionLogin) {
    return {
        type: LoginTypes.LOGIN_REQUEST,
        payload,
    }
}

export function loginSuccess(payload: ResponseLoginSuccess) {
    return {
        type: LoginTypes.LOGIN_SUCCESS,
        payload,
    }
}

export function loginFailure() {
    return {
        type: LoginTypes.LOGIN_FAILURE,
    }
}

// Register

export function registerRequest(payload: InstitutionRegister) {
    return {
        type: RegisterTypes.REGISTER_REQUEST,
        payload,
    }
}

export function registerSuccess() {
    return {
        type: RegisterTypes.REGISTER_SUCCESS,
    }
}

export function registerFailure() {
    return {
        type: RegisterTypes.REGISTER_FAILURE,
    }
}

export function UserSuccessCercOptIn(payload: boolean) {
    return {
        type: UserCerqTypes.SUCCESS_USER_OPT_IN,
        payload,
    }
}

export function UserFailureCercOptIn() {
    return {
        type: UserCerqTypes.FAILURE_USER_OPT_IN,
    }
}

export function refreshTokenAction(payload: RefreshTokenInterface) {
    return {
        type: RefreshTokenTypes.REFRESH_TOKEN,
        payload,
    }
}

export function agendaResponse(payload: AgendaInterface) {
    return {
        type: AgendaTypes.AGENDA_RESPONSE,
        payload,
    }
}
